import { SvgProps } from "../../types";

const Number = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18.86}
    height={18}
    fill="none"
    {...props}>
    <path
      fill="#1280E7"
      d="M6.515 18.213 4.886 15.47 1.8 14.784l.3-3.171-2.1-2.4 2.1-2.4-.3-3.172 3.086-.685L6.515.213l2.914 1.243L12.343.213l1.629 2.743 3.085.685-.3 3.172 2.1 2.4-2.1 2.4.3 3.171-3.085.686-1.629 2.743L9.43 16.97l-2.914 1.243Zm.728-2.186 2.186-.943 2.228.943 1.2-2.057 2.357-.557-.214-2.4 1.586-1.8L15 7.37l.214-2.4-2.357-.514-1.242-2.057-2.186.942L7.2 2.4 6 4.456l-2.357.514.214 2.4-1.585 1.843 1.585 1.8-.214 2.443L6 13.97l1.243 2.057Zm1.286-3.771 4.843-4.843-1.2-1.243-3.643 3.643-1.843-1.8-1.2 1.2 3.043 3.043Z"
    />
  </svg>
);
export default Number;
